import { useContext, useState } from "react";
import { domain } from "../consts";
import { AlertContext } from "../context/AlertContext";
import { SVGS } from ".";
import { validateEmail, validatePassword } from "../utils/validate";
import { SignupStrings } from "../consts/strings";

const SignupForm = ({ setDisplayComponent, formDisplay }) => {
  const { handleAlert } = useContext(AlertContext);
  const [isLoading, setLoading] = useState(false);
  const [form, setForm] = useState({
    name: "",
    surname: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [formErr, setFormErr] = useState({
    email: false,
    password: false,
    confirmPassword: false,
  });

  const handleSignupWithGoogle = () => {
    window.location.href = `${domain}/auth/google`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "email") {
      setFormErr((prev) => ({
        ...prev,
        email: !validateEmail(value),
      }));
    }

    if (name === "password") {
      setFormErr((prev) => ({
        ...prev,
        password: !validatePassword(value),
      }));
    }

    if (name === "password" || name === "confirmPassword") {
      setFormErr((prev) => ({
        ...prev,
        confirmPassword:
          name === "confirmPassword"
            ? form.password !== value
            : value !== form.confirmPassword,
      }));
    }
  };

  const handleFormSignup = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formErr.email || !form.email.length) {
      handleAlert(SignupStrings.emailAlert, "warning");
      setLoading(false);
      return;
    } else if (formErr.password || !form.password.length) {
      handleAlert(SignupStrings.passwordAlert, "warning");
      setLoading(false);
      return;
    } else if (formErr.confirmPassword || !form.confirmPassword.length) {
      handleAlert(SignupStrings.confirmPasswordAlert, "warning");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${domain}/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: form.name,
          surname: form.surname,
          email: form.email,
          password: form.password,
        }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        if (response.status === 403) {
          handleAlert(SignupStrings.userExistsAlert, "error", function () {
            setDisplayComponent(formDisplay.login);
          });
        } else {
          handleAlert(SignupStrings.serverAlert, "error");
        }
        throw new Error(errorMessage);
      }

      setLoading(false);
      handleAlert(
        SignupStrings.verificationEmailSentAlert,
        "info",
        function () {
          setDisplayComponent(formDisplay.login);
        },
      );
    } catch (error) {
      setLoading(false);
      // handleAlert(
      //   "An error occurred during signup. Please try again.",
      //   "error",
      // );
    }
  };

  return (
    <main className="w-full max-w-md mx-auto p-6">
      <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm    ">
        <div className="p-4 sm:p-7">
          <div className="text-center">
            <h1 className="block text-2xl font-bold text-gray-800  ">
              {SignupStrings.header}
            </h1>
            <p className="mt-2 text-sm text-gray-600  ">
              {SignupStrings.paragraph}
              <a
                className="cursor-pointer text-teal-600 decoration-2 hover:underline font-medium  :outline-none  :ring-1  :ring-gray-600"
                onClick={() => setDisplayComponent(formDisplay.login)}
              >
                {" "}
                {SignupStrings.loginButton}
              </a>
            </p>
          </div>

          <div className="mt-5">
            <button
              type="button"
              className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none        :bg-gray-800  :outline-none  :ring-1  :ring-gray-600"
              onClick={handleSignupWithGoogle}
              disabled={isLoading}
            >
              <SVGS.GoogleSVG />
              {SignupStrings.googleButton}
            </button>

            <div className="py-3 flex items-center text-xs text-gray-400 uppercase before:flex-[1_1_0%] before:border-t before:border-gray-200 before:me-6 after:flex-[1_1_0%] after:border-t after:border-gray-200 after:ms-6    :border-gray-600  :border-gray-600">
              {SignupStrings.or}
            </div>

            <form onSubmit={handleFormSignup}>
              <div className="grid gap-y-4">
                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm mb-2  "
                  >
                    {SignupStrings.name}
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="name"
                      name="name"
                      autoComplete="given-name"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="name-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.name && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.name && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="name-error"
                    >
                      {SignupStrings.nameErr}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="surname"
                    className="block text-sm mb-2  "
                  >
                    {SignupStrings.surname}
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      id="surname"
                      name="surname"
                      autoComplete="family-name"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="surname-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.surname && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.surname && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {SignupStrings.surnameErr}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="email"
                    className="block text-sm mb-2  "
                  >
                    {SignupStrings.emailAddress}
                  </label>
                  <div className="relative">
                    <input
                      type="email"
                      id="email"
                      name="email"
                      autoComplete="email"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="email-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.email && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.email && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {SignupStrings.emailAddressErr}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm mb-2  "
                  >
                    {SignupStrings.password}
                  </label>
                  <div className="relative">
                    <input
                      type="password"
                      id="password"
                      name="password"
                      autoComplete="new-password"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="password-error"
                      disabled={isLoading}
                    />

                    <div
                      className={`${
                        !formErr.password && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>

                    <p
                      className={`${
                        !formErr.password && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {SignupStrings.passwordErr}
                    </p>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="confirm-password"
                    className="block text-sm mb-2  "
                  >
                    {SignupStrings.confirmPassword}
                  </label>
                  <div className="relative">
                    <input
                      type="password"
                      id="confirm-password"
                      name="confirmPassword"
                      autoComplete="new-password"
                      onChange={handleChange}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="confirm-password-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.confirmPassword && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.confirmPassword && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {SignupStrings.confirmPasswordErr}
                    </p>
                  </div>
                </div>
                <button
                  type="submit"
                  className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none  :outline-none  :ring-1  :ring-gray-600"
                  disabled={isLoading}
                >
                  {isLoading
                    ? SignupStrings.registerButtonLoading
                    : SignupStrings.registerButton}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default SignupForm;
